import React from 'react';
import { Tooltip } from '@material-ui/core';
import { Edit } from '@material-ui/icons';

const EditIcon = ({
	onClick = () => false,
	tooltip = 'Editar',
	disabled,
	color = 'warning',
	className = '',
}) => {
	return (
		<Tooltip title={tooltip}>
			<span>
				<button
					onClick={onClick}
					disabled={disabled}
					style={{ cursor: disabled ? 'not-allowed' : 'pointer' }}
					className={`btn btn-icon btn-sm btn-${
						disabled ? 'light' : color
					} ${className}`}
				>
					<span className={`svg-icon svg-icon-md`}>
						<Edit/>
					</span>
				</button>
			</span>
		</Tooltip>
	);
};

export default EditIcon;
